<template>
<div class="promotion-introduction-header mt-2" data-component="PromotionIntroduction.vue" :class="{'ml-6': ScreenSize > 1, 'ml-3': ScreenSize <= 1}">
	Włącz Promowanie i bądź widoczny dla osób, które szukają wykonawcy zlecenia!
</div>
<div class="promotion-introduction text-center" data-component="PromotionIntroduction.vue" :class="ScreenSize >= 1 ? 'desktop-introduction' : 'mobile-introduction'">
	<div class="promotion-introduction-item">
		<div class="promotion-introduction-item-header" :class="{ 'mb-4': ScreenSize >= 1}">
			<BaseIcon name="checkmark-circle-1" size="1.75" class="mr-3"/>

			<div class="text-base" :class="{'font-extrabold': ScreenSize < 1, 'mt-[3px] font-bold': ScreenSize >= 1}">
				Co zyskujesz?
			</div>

			<BaseIcon
				v-if="ScreenSize < 1"
				name="chevron-down-2"
				size="1.5"
				class="cursor-pointer mr-1 absolute right-5"
				:class="{
					'rotate-180': isDetailsVisible[0],
				}"
				@click="toggleDetailsVisible(0)"
			/>
		</div>
		<template v-if="ScreenSize >= 1 || isDetailsVisible[0]">
			<div :class="ScreenSize >= 1 ? 'desktop-text-item mb-4' : 'mobile-text-item'">
				<BaseIcon name="dot" size="0.75" class="text-info mt-1"/>
				<div><b>Twoja firma jest widoczna</b> dla tysięcy Zleceniodawców.</div>
			</div>
			<div :class="ScreenSize >= 1 ? 'desktop-text-item mb-4' : 'mobile-text-item'">
				<BaseIcon name="dot" size="0.75" class="text-info mt-1.5"/>
				<div>Dostajesz <b>bezpłatne kontakty</b> do Klientów, którzy wybrali Cię na liście firm.</div>
			</div>
			<div :class="ScreenSize >= 1 ? 'desktop-text-item' : 'mobile-text-item'">
				<BaseIcon name="dot" size="0.75" class="text-info mt-1.5"/>
				<div><b>Trafiasz na szczyty list</b> z najlepszymi firmami w Oferteo.</div>
			</div>
		</template>
	</div>

	<div class="promotion-introduction-item" :class="{'mt-4': ScreenSize < 1}">
		<div class="promotion-introduction-item-header" :class="{ 'mb-4': ScreenSize >= 1}">
			<BaseIcon name="light-bulb" size="1.75" class="text-warn-500 mr-3"/>

			<div class="text-base" :class="{'font-extrabold': ScreenSize < 1, 'mt-[3px] font-bold': ScreenSize >= 1}">
				Jak włączyć Promowanie?
			</div>

			<BaseIcon
				v-if="ScreenSize < 1"
				name="chevron-down-2"
				size="1.5"
				class="cursor-pointer mr-1 absolute right-5"
				:class="{
					'rotate-180': isDetailsVisible[1],
				}"
				@click="toggleDetailsVisible(1)"
			/>
		</div>
		<template v-if="ScreenSize >=1 || isDetailsVisible[1]">
			<div :class="ScreenSize >= 1 ? 'desktop-text-item mb-4' : 'mobile-text-item'">
				<b>1.</b><div><b>Wybierz kategorie,</b> w których zależy Ci na dodatkowej widoczności.</div>
			</div>
			<div :class="ScreenSize >= 1 ? 'desktop-text-item mb-4' : 'mobile-text-item'">
				<b>2.</b><div><b>Potwierdź zakup</b> - zapłacisz punktami Oferteo.</div>
			</div>
			<div :class="ScreenSize >= 1 ? 'desktop-text-item' : 'mobile-text-item'">
				<b>3.</b><div><b>Zyskuj bezpłatne kontakty</b> i realizuj zlecenia Klientów.</div>
			</div>
		</template>
	</div>
</div>

<div class="mt-4 mb-1 text-right text-info" data-component="PromotionIntroduction.vue" :class="{'mr-4': ScreenSize <= 1}">
	<span class="cursor-pointer font-bold text-sm" @click="sendSystemNoteAndRedirect">Dowiedz się więcej</span>
</div>
</template>
<script lang="ts">
import serverFetch from '../../../globals/ServerFetch';

export default {
	name: 'PromotionIntroduction',
	data() {
		return {
			isDetailsVisible: [false, false],
		};
	},
	methods: {
		toggleDetailsVisible(index: number) {
			this.isDetailsVisible[index] = !this.isDetailsVisible[index];
		},
		async sendSystemNoteAndRedirect() {
			await serverFetch('/promotion/add-promotion-note.ofer');

			window.open('/konto/promowanie', '_blank');
		},
	},
};

</script>
<style lang="scss" scoped>
.promotion-introduction .promotion-introduction-item {
	border-radius: 8px;
	border: 1px solid #E6E6E6;
	box-shadow: 0px 1px 4px 2px rgba(0, 0, 0, 0.04), 0.25px 1.5px 2px 0px rgba(0, 0, 0, 0.08);
	background: #FFF;
	.promotion-introduction-item-header {
		display: flex;
		font-weight: 700;
		text-align: left;
	}
	.mobile-text-item {
		display: flex;
		text-align: left;
		margin-top: 1rem;

		div {
			margin-left: 4px;
		}
	}

	.desktop-text-item {
		display: flex;
		text-align: left;

		div {
			margin-left: 4px;
		}
	}

}

.promotion-introduction.desktop-introduction {
	display: flex;
    gap: 16px;
	padding: 1.5rem 0 1rem 1rem;

	.promotion-introduction-item {
		padding: 24px;
	}
    .promotion-introduction-item:first-child {
        max-width: calc(50% - 8px);
    }
}

.promotion-introduction.mobile-introduction {
	display: block;
	padding: 0.5rem;

	.promotion-introduction-item {
		padding: 12px;
	}
}

</style>
